import React, { createContext, useState, useContext } from 'react';
import { translations } from './translations'; // Importieren unserer Texte

// 1. Context erstellen
const LanguageContext = createContext();

// 2. Provider-Komponente erstellen (diese "umhüllt" später unsere App)
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('de'); // Standard-Sprache ist Deutsch

    const t = (key) => {
        return translations[language][key] || key;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

// 3. Einen einfachen Hook erstellen, um den Context in Komponenten zu nutzen
export const useLanguage = () => {
    return useContext(LanguageContext);
};